module.exports = __webpack_public_path__ + "static/media/user-account-bg.ca3684a7.png";